import { createStore } from "zustand";

import { getUUID } from "@/lib/uuid/get-uuid";

export type FeatureIslandCategoryStoreType = {
	categoryID: string;

	/**
	 * カテゴリーのタイトル
	 */
	title: string;

	/**
	 * カテゴリーの説明
	 */
	description: string;

	/**
	 * 基本設定に含まれるかどうか
	 */
	isBasicSetup: boolean;

	/**
	 * このカテゴリー内の設定項目にエラーがあるかどうか
	 */
	hasError: boolean;

	/**
	 * エラーがあるQuestionのタイトル
	 */
	errorQuestionTitles: Set<string>;
	addErrorQuestionTitle: (questionTitle: string) => void;
	removeErrorQuestionTitle: (questionTitle: string) => void;

	/**
	 * このカテゴリー内の設定項目の１つ以上が編集されているかどうか
	 */
	isEdited: boolean;
	editedQuestionTitles: Set<string>;
	addEditedQuestionTitle: (questionTitle: string) => void;
	removeEditedQuestionTitle: (questionTitle: string) => void;
};

export type FeatureIslandCategoryStore = ReturnType<typeof createFeatureIslandCategoryStore>;

export const createFeatureIslandCategoryStore = ({
	title,
	description,
	isBasicSetup,
}: Pick<FeatureIslandCategoryStoreType, "title" | "description" | "isBasicSetup">) => {
	return createStore<FeatureIslandCategoryStoreType>((set) => ({
		categoryID: getUUID(),

		title,
		description,
		isBasicSetup,

		hasError: false,
		errorQuestionTitles: new Set<string>(),
		addErrorQuestionTitle: (questionTitle: string) => {
			set((state) => {
				const newErrorQuestionTitles = state.errorQuestionTitles.add(questionTitle);

				return {
					...state,
					hasError: newErrorQuestionTitles.size > 0,
					errorQuestionTitles: newErrorQuestionTitles,
				};
			});
		},
		removeErrorQuestionTitle: (questionTitle: string) => {
			set((state) => {
				const newErrorQuestionTitles = state.errorQuestionTitles.delete(questionTitle)
					? state.errorQuestionTitles
					: state.errorQuestionTitles;

				return {
					...state,
					hasError: newErrorQuestionTitles.size > 0,
					errorQuestionTitles: newErrorQuestionTitles,
				};
			});
		},

		isEdited: false,
		editedQuestionTitles: new Set<string>(),
		addEditedQuestionTitle: (questionTitle: string) => {
			set((state) => {
				const newEditedQuestionTitles = state.editedQuestionTitles.add(questionTitle);

				return {
					...state,
					isEdited: newEditedQuestionTitles.size > 0,
					editedQuestionTitles: newEditedQuestionTitles,
				};
			});
		},
		removeEditedQuestionTitle: (questionTitle: string) => {
			set((state) => {
				const newEditedQuestionTitles = state.editedQuestionTitles.delete(questionTitle)
					? state.editedQuestionTitles
					: state.editedQuestionTitles;

				return {
					...state,
					isEdited: newEditedQuestionTitles.size > 0,
					editedQuestionTitles: newEditedQuestionTitles,
				};
			});
		},
	}));
};
